import React, { useState, useEffect } from "react";

export default function UsageMeter({ organizationId }) {
  const [usageData, setUsageData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsageData = async () => {
      if (!organizationId) {
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        const response = await fetch(
          "https://nodejs-serverless-function-express-azure-delta.vercel.app/api/team-usage",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ organizationId }),
          }
        );
        if (!response.ok) {
          const errorResponse = await response.json();
          throw new Error(errorResponse.error || "Unknown error");
        }
        const data = await response.json();
        setUsageData(data);
      } catch (error) {
        console.error("Error fetching usage data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsageData();
  }, [organizationId]);

  if (loading) {
    return (
      <div className="w-full p-4 border rounded-lg shadow-sm bg-white my-2 animate-pulse">
        <h3 className="text-lg font-semibold text-gray-800 mb-2">
          <div className="h-6 bg-gray-200 rounded w-1/3"></div>
        </h3>
        <p className="text-sm text-gray-600">
          <div className="h-4 bg-gray-200 rounded w-2/3 mt-2"></div>
        </p>
        <div className="w-full bg-gray-200 rounded-full h-4 mt-4">
          <div
            className="h-4 bg-gray-300 rounded-full animate-pulse"
            style={{ width: "50%" }}
          ></div>
        </div>
        <div className="h-4 bg-gray-200 rounded w-1/2 mt-4"></div>
      </div>
    );
  }

  if (!usageData) {
    return (
      <div className="w-full p-4 border rounded-lg shadow-sm bg-white my-2">
        <p className="text-sm text-red-500">Unable to load usage data.</p>
      </div>
    );
  }

  // Calculate percentages for team and admin usage
  const teamUsagePercentage =
    usageData.maxUsers > 0
      ? Math.min((usageData.currentUsers / usageData.maxUsers) * 100, 100)
      : 0;
  const adminUsagePercentage =
    usageData.maxAdmin > 0
      ? Math.min((usageData.currentAdmin / usageData.maxAdmin) * 100, 100)
      : 0;

  return (
    <div>
      {/* Team Usage Meter */}
      <div className="w-full p-4 border rounded-lg shadow-sm bg-white my-2">
        <h3 className="text-lg font-semibold text-gray-800 mb-2">
          Total Team Usage
        </h3>
        <p className="text-sm text-gray-600">
          {`You are using ${usageData.currentUsers} of ${usageData.maxUsers} team slots.`}
        </p>
        <div className="w-full bg-gray-200 rounded-full h-3 mt-2">
          <div
            className={`h-3 rounded-full ${
              teamUsagePercentage < 65
                ? "bg-green-500"
                : teamUsagePercentage < 100
                ? "bg-yellow-500"
                : "bg-red-500"
            }`}
            style={{ width: `${teamUsagePercentage}%` }}
          ></div>
        </div>
        {teamUsagePercentage === 100 && (
          <p className="text-sm text-red-500 mt-2">
            You've reached the maximum number of team members. Upgrade to add more slots.
          </p>
        )}

        {/* <hr className="my-4 border-gray-200" />

        <h3 className="text-lg font-semibold text-gray-800 mb-2">
          Admin Seat Usage
        </h3>
        <p className="text-sm text-gray-600">
          {`You are using ${usageData.currentAdmin} of ${usageData.maxAdmin} admin seats.`}
        </p>
        <div className="w-full bg-gray-200 rounded-full h-3 mt-2">
          <div
            className={`h-3 rounded-full ${
              adminUsagePercentage < 65
                ? "bg-green-500"
                : adminUsagePercentage < 100
                ? "bg-yellow-500"
                : "bg-red-500"
            }`}
            style={{ width: `${adminUsagePercentage}%` }}
          ></div>
        </div>
        {adminUsagePercentage === 100 && (
          <p className="text-sm text-red-500 mt-2">
            You've reached the maximum number of admin seats. Upgrade your subscription or purchase more slots.
          </p>
        )} */}

      </div>

    </div>
  );
}
